<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <b>Version</b> {{ appVersion }}
  </div>
  <strong
    >Copyright &copy; 2024 </strong
    >
    <a href="https://swapinfotech.com" class="branding">SwapInfotech.com</a>
  All rights reserved.
</footer>
